import { gql } from '@apollo/client';
import { Classification, Participant, ParticipantGender, Corporation } from '../core/api/model';

/* ASSUMPTIONS
 * participant (expoCode: $expoCode, partId: $partId).length = 1
 */

export interface ProfileForm {
  partGender: ParticipantGender;
  partName: string;
  partSurname: string;
  partEmail1: string;
  partTimezoneOffset: number;
  corpId: number;
  partIndustry: string;
  partProfPosition: string;
  partResponsibility: string;
  partFunction: string;
  classification: number[];
}

export interface ProfileQueryVariables {
  expoCode: string;
}

export interface ProfileQueryData {
  participant: Participant[];
  corporation: Corporation[];
  classification: Classification[];
  __type: {
    TeilnehmerBeruflicheStellung: { key: string, description: string }[];
  }
}

export const PROFILE_QUERY = gql`
  query Profile($expoCode: String!) {
    participant (expoCode: $expoCode, currentUser: true) {
        partId,
        partLanguage,
        partGender,
        partName,
        partSurname,
        partEmail1,
        partTimezoneOffset,
        corporation {
          corpId,
          corpName {
            de_DE
            en_GB
          }
        }
        partCompany2,
        partIndustry,
        partProfPosition,
        partResponsibility,
        partFunction,
        classification {
          classificationId
        },
        partPic(size: S240x240) {
          url
          altText
        }
    }
    __type(name: "TeilnehmerBeruflicheStellung") {
      TeilnehmerBeruflicheStellung: enumValues {
          key: name
          description
      }
    }
    corporation(expoCode: $expoCode) {
      corpId,
      corpName {
        de_DE
        en_GB
      }
    }
    classification(classificationType: [ TOPIC, VESTED_INTEREST, PRODUCTCATEGORY ]) {
        classificationId,
        classificationTitle {
            de_DE
            en_GB
        },
    }
  }
`;

// @TODO REFACTORING combine the following two queries
export const PROFILE_MUTATION = gql`
  mutation Profile(
    $partId: Int!
    $expoCode: String!
    $partEmail1: String!
    $partLanguage: String!
    $partGender: TeilnehmerGeschlecht!
    $partName: String!
    $partSurname: String!
    $partTimezoneOffset: Int!
    #$corpId: Int!
    $partCompany2: String!
    $partIndustry: String!
    $partProfPosition: TeilnehmerBeruflicheStellung!
    $partResponsibility: String!
    $partFunction: String!
    $classificationId: [Int]!
  ) {
      participant (
          input: {
              participant: [
                  {
                    partId: $partId
                    expoCode: $expoCode
                    partEmail1: $partEmail1
                    partLanguage: $partLanguage
                    partVar: PARTICIPANT
                    partGender: $partGender
                    partName: $partName
                    partSurname: $partSurname
                    partTimezoneOffset: $partTimezoneOffset
                    #corpId: $corpId
                    partCompany2: $partCompany2
                    partIndustry: $partIndustry
                    partProfPosition: $partProfPosition
                    partResponsibility: $partResponsibility
                    partFunction: $partFunction
                    classificationId: $classificationId
                  }
              ]
          }
      )
      {
          partEmail1
          partChangeDate
      }
  }
`;
export const PROFILE_MUTATION_WO_PART_PROF_POSITION = gql`
  mutation Profile(
    $partId: Int!
    $expoCode: String!
    $partEmail1: String!
    $partLanguage: String!
    $partGender: TeilnehmerGeschlecht!
    $partName: String!
    $partSurname: String!
    $partTimezoneOffset: Int!
    #$corpId: Int!
    $partCompany2: String!
    $partIndustry: String!
    $partResponsibility: String!
    $partFunction: String!
    $classificationId: [Int]!
  ) {
      participant (
          input: {
              participant: [
                  {
                    partId: $partId
                    expoCode: $expoCode
                    partEmail1: $partEmail1
                    partLanguage: $partLanguage
                    partVar: PARTICIPANT
                    partGender: $partGender
                    partName: $partName
                    partSurname: $partSurname
                    partTimezoneOffset: $partTimezoneOffset
                    #corpId: $corpId
                    partCompany2: $partCompany2
                    partIndustry: $partIndustry
                    partResponsibility: $partResponsibility
                    partFunction: $partFunction
                    classificationId: $classificationId
                  }
              ]
          }
      )
      {
          partEmail1
          partChangeDate
      }
  
  }
`;
